import { computed, type ComputedRef } from 'vue'

export function useThemeOverrides(isDark: ComputedRef<boolean>) {
  return computed(() => ({
    common: {
      primaryColor: isDark.value ? '#fff' : '#242529',
    },
    Scrollbar: {
      color: isDark.value ? 'rgba(255, 255, 255, 0.08)' : 'rgba(138, 150, 163, 0.25)',
      colorHover: isDark.value ? 'rgba(255, 255, 255, 0.08)' : 'rgba(138, 150, 163, 0.25)',
    },
    AvatarGroup: {
      gap: '-24px',
    },
    Avatar: {
      border: isDark.value ? '1px solid #161618' : '1px solid #fff',
      borderRadius: '4px',
    },
    Calendar: {
      borderRadius: '0',
      borderColor: 'rgba(138, 150, 163, 0.25)',
      titleFontSize: '16px',
      borderColorModal: 'rgba(255, 255, 255, 0.04)',
      borderColorPopover: 'rgba(255, 255, 255, 0.04)',
      textColor: isDark.value ? '#fff' : '#242529',
      dayTextColor: isDark.value ? 'rgba(255, 255, 255, 0.3)' : '#8A96A3',
      lineHeight: '1.5',
      dateColorCurrent: 'transparent',
      dateTextColorCurrent: isDark.value ? '#fff' : '#242529',
      cellColorModal: 'rgba(44, 44, 50, 0)',
      barColor: '#FFFFff00',
    },
    DatePicker: {
      itemCellWidth: '43px',
      itemCellHeight: '40px',
      itemTextColorActive: '#161618',
      panelTextColor: '#fff',
    },
    Slider: {
      handleSize: '12px',
    },
    Dropdown: {
      borderRadius: '6px',
      dividerColor: 'rgba(138, 150, 163, 0.25)',
      color: 'rgba(48, 51, 53, 1)',
      optionColorHover: 'rgba(255, 255, 255, 0.06)',
    },
    Popover: {
      borderRadius: '4px',
      color: 'rgba(22, 22, 24, 1)',
      textColor: isDark.value ? '#fff' : '#8A96A3',
    },
    Input: {
      textColor: isDark.value ? '#fff' : '#242529',
      caretColor: isDark.value ? '#FFF' : '#242529',
      border: isDark.value ? '1px solid rgba(138, 150, 163, 0.5)' : '1px solid #C4CAD1',
      borderHover: isDark.value ? '1px solid #8A96A3' : '1px solid #9E9E9E',
      borderFocus: isDark.value ? '1px solid #F6F7F8' : '1px solid #666666',
      boxShadowFocus: 'none',
      borderRadius: '6px',
      placeholderColor: 'rgba(138, 150, 163, 0.75)',
      loadingColor: isDark.value ? '#FFF' : '#242529',
      heightMedium: '44px',
      fontSizeMedium: '16px',
      color: 'transparent',
      colorFocus: 'transparent',
      height: '44px',
      lineHeight: '44px',
      arrowSize: '24px',
      labelHeight: '30px',
      caretColorError: 'rgb(246, 70, 93)',
      loadingColorError: ' rgb(246, 70, 93)',
      borderError: '1px solid #FF6060',
      borderHoverError: '1px solid rgb(246, 70, 93)',
      boxShadowFocusError: '', // 0 0 0 1px rgb(246, 70, 93)
      borderFocusError: '1px solid rgb(246, 70, 93)',
    },
    Select: {
      height: '44px',
    },
    Form: {
      feedbackTextColorError: '#FF6060',
    },
  }))
}
